module.exports = __webpack_public_path__ + "assets/media/regenerate.a7b62862.svg";